import { Type, type SchemaOptions } from '@sinclair/typebox';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY = 'PRICE_TYPE_';

// ⚠️ IMPACT : enum dual-défini — toute modification doit être répercutée dans
// `packages/backend/prisma-pg/schema.prisma` (enum PriceType, MÊME contenu ET MÊME ordre)
// avec un fichier de migration `ALTER TYPE ... ADD VALUE`.
export enum PriceType {
  FIXED = 'FIXED',
  /** Prix ferme à 0 € : équivalent d'un FIXED à 0, sans montant à saisir par le pro. */
  FREE = 'FREE',
  FROM = 'FROM',
  QUOTE = 'QUOTE',
  NONE = 'NONE',
}

export const PriceTypeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY}${PriceType.FIXED}`]: 'Fixe',
    [`${TRANSLATE_KEY}${PriceType.FREE}`]: 'Gratuit',
    [`${TRANSLATE_KEY}${PriceType.FROM}`]: 'A partir de',
    [`${TRANSLATE_KEY}${PriceType.QUOTE}`]: 'Devis',
    [`${TRANSLATE_KEY}${PriceType.NONE}`]: 'Prix indéterminé',
  },
  'en-US': {
    [`${TRANSLATE_KEY}${PriceType.FIXED}`]: 'Fixed',
    [`${TRANSLATE_KEY}${PriceType.FREE}`]: 'Free',
    [`${TRANSLATE_KEY}${PriceType.FROM}`]: 'Starting from',
    [`${TRANSLATE_KEY}${PriceType.QUOTE}`]: 'Quote',
    [`${TRANSLATE_KEY}${PriceType.NONE}`]: 'Undetermined price',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(PriceType, PriceTypeTranslation, TRANSLATE_KEY, true);

export const PriceTypeSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(PriceType).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY}${value}`,
      }),
    ),
    options,
  );
};
